import React, { useEffect, useState } from 'react'
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import HeaderComponent from '@components/header.component'
import FooterComponent from '@components/footer.component'
import LoginPage from '@pages/login.page'
import NotFoundPage from '@pages/notFound.page'
import { useTheme } from '@config/theme.config'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import HelpPage from '@pages/help.page'
import NewsPage from '@pages/news.page'
import BroadcastPage from '@pages/broadcast.page'
import AudioPage from '@pages/audio.page'
import { AppDispatch } from '@store/store'
import { fetchUserdata } from '@store/thunk/auth.thunk'
import { selectIsLoggedIn } from '@store/slices/auth.slice'
import RegionsPage from "@pages/regions.page";

const App: React.FC = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const dispatch: AppDispatch = useDispatch()
  const { theme } = useTheme()
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false)

  async function loadUserData() {
    // Ensure dispatch is available here (use useDispatch if in component or receive it via params)
    await dispatch(fetchUserdata())
  }

  useEffect(() => {
    // Fetch user data
    loadUserData().then(() => {
      setIsUserDataLoaded(true)
    })
  }, [])

  const PrivateWrapper = () => {
    return isLoggedIn ? <Outlet /> : <Navigate to="/login" />
  }

  if (!isUserDataLoaded) {
    return <div>Loading...</div> // or a loading spinner
  }

  return (
    <div
      className={`d-flex flex-column min-vh-100 bg-dark-subtle overflow-hidden`}
      data-bs-theme={theme}
    >
      {!isUserDataLoaded ? (
        <div>Loading...</div>
      ) : (
        <BrowserRouter>
          {isLoggedIn && <HeaderComponent />}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={theme}
          ></ToastContainer>
          <div className="flex-grow-1">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<PrivateWrapper />}>
                <Route path="/help" element={<HelpPage />} />
                <Route path="/" element={<NewsPage />} />
                <Route path="/program" element={<BroadcastPage />} />
                <Route path="/audio" element={<AudioPage />} />
                <Route path="/regions" element={<RegionsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </div>
          {isLoggedIn && <FooterComponent />}
        </BrowserRouter>
      )}
    </div>
  )
}

export default App
